<template>
    <section class="product-card replacement-card" :class="view">
        <div class="product-card__img-container">
            <img class="product-card__img" src="@/assets/images/good-img.webp" alt="изображение продукта">
            <!-- <p class="product-card__added-amount">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2201_26380)">
                        <path
                            d="M20.8406 7.51127C20.7069 7.3484 20.5074 7.25405 20.2969 7.25405H7.54409L7.16259 5.09455C7.12551 4.88444 6.99491 4.70248 6.80759 4.60003L4.04069 3.08639C3.69997 2.90003 3.27274 3.02514 3.08639 3.36585C2.90003 3.70657 3.02514 4.1338 3.36585 4.32015L5.83654 5.67175L7.841 17.0206C7.10354 17.339 6.58608 18.073 6.58608 18.9258C6.58608 20.0696 7.51649 21 8.6603 21C9.5572 21 10.3228 20.4276 10.6115 19.6289H14.7245C15.0131 20.4276 15.7788 21 16.6758 21C17.8195 21 18.75 20.0696 18.75 18.9258C18.75 17.7821 17.8195 16.8516 16.6758 16.8516C15.7788 16.8516 15.0131 17.424 14.7245 18.2227H10.6115C10.3893 17.608 9.88445 17.1276 9.25452 16.9388L8.99703 15.4805H17.2059C18.5424 15.4805 19.7024 14.5292 19.9639 13.2184C20.0399 12.8376 19.7927 12.4673 19.4119 12.3914C19.0313 12.3155 18.6609 12.5624 18.5849 12.9432C18.4541 13.5987 17.8741 14.0742 17.2059 14.0742H17.1761L17.6609 8.6603H19.4395L19.1653 10.0344C19.0893 10.4152 19.3364 10.7855 19.7172 10.8615C19.7638 10.8708 19.8099 10.8753 19.8556 10.8753C20.184 10.8753 20.4776 10.6439 20.5443 10.3096L20.9864 8.09478C21.0276 7.88824 20.9741 7.67414 20.8406 7.51127ZM12.9492 8.6603V14.0742H11.5758L11.0909 8.6603H12.9492ZM8.6603 19.5938C8.29185 19.5938 7.99233 19.2941 7.99233 18.9258C7.99233 18.5575 8.29185 18.2578 8.6603 18.2578C9.02862 18.2578 9.32813 18.5575 9.32813 18.9258C9.32813 19.2941 9.02848 19.5938 8.6603 19.5938ZM16.6758 18.2578C17.0441 18.2578 17.3438 18.5575 17.3438 18.9258C17.3438 19.2941 17.0441 19.5938 16.6758 19.5938C16.3391 19.5938 16.0606 19.3431 16.0151 19.0186C16.0191 18.9883 16.022 18.9574 16.022 18.9258C16.022 18.8942 16.0191 18.8634 16.0151 18.833C16.0606 18.5086 16.3391 18.2578 16.6758 18.2578ZM7.79238 8.6603H9.67901L10.1639 14.0742H8.7486L7.79238 8.6603ZM15.7642 14.0742H14.3555V8.6603H16.249L15.7642 14.0742Z"
                            fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_2201_26380">
                            <rect width="18" height="18" fill="white" transform="translate(3 3)" />
                        </clipPath>
                    </defs>
                </svg>
                <span>{{ amount }}</span>
            </p> -->
        </div>
        <div class="product-card__info">
            <div class="name-price-container">
                <router-link class="product-card__name" :to="{ name: 'product', params: { id: id } }">{{ name }}</router-link>
                <p class="product-card__price">{{ price }} ₽</p>
            </div>
            <p class="product-card__articul">Арт. {{ articul }}</p>
            <div class="product-card__bottom">
                <amount-block :amount="amount" @amountChange="amountChange"></amount-block>
                <button class="product-card__button" :class="{ choosed: choosed }" type="button" @click="chooseGood">{{
                    buttonText }}</button>
            </div>
        </div>
    </section>
</template>

<script>
import AmountBlock from './AmountBlock.vue';

export default {
    name: 'ReplacementCard',

    components: {
        AmountBlock
    },

    emits: ['cardChoosen', 'amountChange'],

    props: {
        id: {
            type: Number,
            default() {
                return 0
            }
        },
        amount: {
            type: Number,
            default() {
                return 0
            }
        },
        articul: {
            type: String,
            default() {
                return 'FBK0500219'
            }
        },
        name: {
            type: String,
            default() {
                return "Товар"
            }
        },
        price: {
            type: Number,
            default() {
                return 0
            }
        },
        image: {
            type: String,
            default() {
                return ""
            }
        },
        view: {
            type: String,
            default() {
                return "normal"
            }
        },
        choosed: {
            type: Boolean,
            default() {
                return false
            }
        },
    },
    data() {
        return {
            addToCartAmount: 1
        }
    },

    created() {

    },

    beforeUnmount() {

    },

    computed: {
        positionLenght() {
            return this.positions.length
        },

        buttonText() {
            if (this.choosed) {
                return 'выбран'
            }
            else {
                return 'заменить'
            }
        }
    },

    methods: {
        amountChange(amount) {
            this.$emit('amountChange', this.id, amount)
        },

        chooseGood() {
            if (this.choosed == false) {
                this.$emit("cardChoosen", this.id)
            }
        }
    }

}
</script>

<style lang="scss">
.replacement-card {
    .product-card__button {
        @extend %button;

        padding: 6px 12px;

        border-radius: 6px;

        white-space: nowrap;

        user-select: none;

        text-transform: capitalize;

        transition: opacity .3s;

        &.choosed {
            opacity: .7;
            pointer-events: none;
        }
    }
}
</style>